// extracted by mini-css-extract-plugin
module.exports = {"toggle":"cc_toggle_1014780759","tw-icon":"cc_tw-icon_1014780759","twIcon":"cc_tw-icon_1014780759"};